<template>
  <div>
    <VoucherSurvey />
  </div>
</template>

<script>
import VoucherSurvey from "@/components/DigitalVoucherSurvey.vue";
import FullPageLayout from "../layouts/FullPageLayout";

export default {
  components: {
    VoucherSurvey
  },
  created() {
    this.$emit(`update:layout`, FullPageLayout);
  }
};
</script>